import * as React from 'react'

const SvgTextAlignCenterIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.75 3.75h12.5V5H3.75V3.75zm2.5 3.75h7.5v1.25h-7.5V7.5zm-2.5 3.75h12.5v1.25H3.75v-1.25zM6.25 15h7.5v1.25h-7.5V15z"
      fill="#163250"
    />
  </svg>
)

export default SvgTextAlignCenterIcon
